import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router'

import { Assessment, Dashboard, FindInPage, Home, ListAlt, Portrait, VerifiedUser } from '@mui/icons-material'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'

import Container from './styles'
import NavigationItem from './NavigationItem'

const Navigation = () => {
  const location = useLocation()
  const [value, setValue] = useState(location.pathname)
  const token = useSelector((state) => state.auth.access_token)

  const decoded = jwtDecode(token)
  const { role } = decoded.extras

  const handleOnClick = (event) => {
    const route = event.target.getAttribute('data')
    if (route && route !== value) {
      setValue(route)
      gotoUrl(route)
    }
  }

  useEffect(() => {
    if (value !== location.pathname) setValue(location.pathname)
  }, [location.pathname])

  return (
    <Container>
      <NavigationItem
        label={role === 'Prospect' ? 'Home' : 'Aplicações'}
        href={
          role === 'Prospect'
            ? ROUTE_CONSTANTS.PROSPECT_DASHBOARD
            : ROUTE_CONSTANTS.HOME
        }
        value={value}
        icon={role === 'Prospect' ? <Home fontSize='small'/> : <Portrait fontSize='small' />}
        onClick={handleOnClick}
      />
      {role !== 'Prospect' ? (
        <React.Fragment>
          <NavigationItem
            label="análises manuais"
            href={ROUTE_CONSTANTS.MANUAL_ANALISYS_AUDIT}
            value={value}
            icon={<FindInPage fontSize="small" />}
            onClick={handleOnClick}
          />
          <NavigationItem
            label="Estatísticas"
            href={ROUTE_CONSTANTS.STATISTICS}
            value={value}
            icon={<Assessment fontSize="small" />}
            onClick={handleOnClick}
          />
          <NavigationItem
            label="Formulários Due Diligence"
            href={ROUTE_CONSTANTS.DUE_DILIGENCE_LIST}
            value={value}
            icon={<ListAlt fontSize="small" />}
            onClick={handleOnClick}
          />
          <NavigationItem
            label="Background Check"
            href={ROUTE_CONSTANTS.BACKGROUND_CHECK}
            value={value}
            icon={<VerifiedUser fontSize="small" />}
            onClick={handleOnClick}
          />
          <NavigationItem
            label="Antifraude"
            href={ROUTE_CONSTANTS.ANTIFRAUDE_DASHBOARD}
            value={value}
            icon={<Dashboard fontSize="small" />}
            onClick={handleOnClick}
          />
        </React.Fragment>
      ) : null}
    </Container>
  )
}

export default Navigation
